import { z } from 'zod';

export const portugalPostalCodeSchema = z
  .string()
  .regex(/^\d{4}-\d{3}$/, 'Código postal inválido (formato 0000-000)');

export const addressSchema = z.object({
  label: z.string().max(50).nullable().optional(),
  firstName: z.string().min(1, 'Nome obrigatório').max(100),
  lastName: z.string().min(1, 'Apelido obrigatório').max(100),
  addressLine1: z.string().min(1, 'Morada obrigatória').max(255),
  addressLine2: z.string().max(255).nullable().optional(),
  city: z.string().min(1, 'Localidade obrigatória').max(100),
  postalCode: portugalPostalCodeSchema,
  district: z.string().min(1, 'Distrito obrigatório').max(100),
  country: z.string().min(2).max(100).default('PT'),
  isDefaultShipping: z.boolean().default(false),
  isDefaultBilling: z.boolean().default(false),
});

export const addressUpdateSchema = addressSchema.partial();

export type AddressInput = z.infer<typeof addressSchema>;
export type AddressUpdateInput = z.infer<typeof addressUpdateSchema>;
